module.exports = __webpack_public_path__ + "static/img/shoppting-cart-points.f90b972.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/shoppting-cart-points.png
// module id = PzDq
// module chunks = 1